module.exports = __webpack_public_path__ + "img/title-timetable.95187862.svg";